import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Quick Links Section */}
        <div className="footer-links">
        <img className="logo1" src="./slogo.png" alt="logo" />
          <p>
          At Sujay Industries, we engineer innovative solutions with excellence,
           shaping a sustainable future for businesses and communities worldwide
          </p>
          
          
        </div>

        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/facilities">Facilities</a></li>
            <li><a href="/contact">Contact</a></li>
            
          </ul>
        </div>

        {/* Address Section */}
        <div className="footer-address">
          <h4>Contact Us</h4>
          <address>
          No. 136B, KIADB Industrial 
Area, Jigani Bommasandra 
Link Road, Bangalore 
560105<br />
            <a href="tel:9900415325">+91-9900415325</a><br />
            <a href="mailto:niranjanu@sujayindustries.in">niranjanu@sujayindustries.in</a>
          </address>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-bottom">
        <p>&copy; 2024 sujay Industries. All rights reserved.</p>
        <p>Design And Developed by :<a href="https://www.tackled.co.in/" className="contact-link"> Tackle-D</a> </p>
      </div>
    </footer>
  );
};

export default Footer;
